import axios from 'axios';
import { z } from 'zod';
import { configRefs } from '@utils/constants';

const fontVariantSchema = z.enum(["default", "dyslexie"]).catch("default");
async function getUserPreferences(userId) {
  var _a, _b;
  if (userId === void 0) {
    return null;
  }
  const res = await axios.get(
    `${await configRefs.apis.userdata.get()}/api/Preferences?userID=${userId}`
  );
  const portalPreferences = (res.data ?? []).find(
    (preferences) => preferences.system === "portal"
  );
  if (!portalPreferences || !portalPreferences.textToSpeech) {
    return null;
  }
  return {
    objectId: portalPreferences.objectID,
    speechSynthesis: {
      gender: inferGenderFromResponse(portalPreferences.textToSpeech.voice),
      speed: portalPreferences.textToSpeech.speed
    },
    font: fontVariantSchema.parse((_b = (_a = portalPreferences.settings) == null ? void 0 : _a[0]) == null ? void 0 : _b.fontType)
  };
}
function inferGenderFromResponse(voice) {
  switch (voice) {
    case "Male":
      return "male";
    case "Female":
      return "female";
    default:
      return void 0;
  }
}

export { getUserPreferences };
//# sourceMappingURL=request.get-user-preferences.js.map
